import { readBinaryMeta } from '@givmo/api-client';

interface CsvExportResult {
  data?: unknown;
  error?: unknown;
  response?: Response;
}

export type CsvExportCall = () => Promise<CsvExportResult>;

export function blobSave(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  anchor.style.display = 'none';
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  URL.revokeObjectURL(url);
}

export async function runCsvDownload(call: CsvExportCall, fallbackFilename: string): Promise<void> {
  const result = await call();
  if (result.error) throw result.error;
  if (!result.response) throw new Error('Export failed: no response.');
  const meta = readBinaryMeta(result.response);
  const blob =
    result.data instanceof Blob
      ? result.data
      : new Blob([(result.data ?? '') as BlobPart], { type: 'text/csv' });
  blobSave(blob, meta.filename ?? fallbackFilename);
}

export function fallbackCsvName(kind: 'crm-donors' | 'imported-contacts'): string {
  const stem = kind === 'crm-donors' ? 'givmo_crm_donors' : 'givmo_imported_contacts';
  return `${stem}_${new Date().toISOString().slice(0, 10)}.csv`;
}
